import { render, staticRenderFns } from "./Tema7.vue?vue&type=template&id=1ef96722&lang=pug&"
import script from "./Tema7.vue?vue&type=script&lang=js&"
export * from "./Tema7.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports